import common from '@metarhia/common';
import debug from 'debug';

import { isDevEnv } from '../../helpers';

/**
 * Debug logger function.
 *
 * @param fmt - Format string with percent-placeholders.
 * @param args - Format string placeholders values.
 */
type DebugLogger = (fmt: string, ...args: any[]) => void;

/**
 * Creates a debug logger function.
 *
 * The logger does nothing in production builds.
 *
 * @param namespace - Namespace to prepend to log entries.
 */
export const createDebugLogger = (namespace: string): DebugLogger =>
  isDevEnv() ? debug(`console:${namespace}`) : common.emptiness;

export default DebugLogger;
